// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"MessagePage_wrapper__11PGj","title":"MessagePage_title__1ZlZ2","titleStatus":"MessagePage_titleStatus__Jw0Dc","returnLink":"MessagePage_returnLink__26TNY"};